import React, {useState} from "react";
import type {MatchDetail, Table} from '@iziping/common';
import {useTranslation} from "react-i18next";
import {useFindAvailableTables, useLaunchMatch} from "./matchesHooks";
import { useTournamentStore } from '../../service/useTournamentStore';
import {useQueryClient} from "@tanstack/react-query";
import { QUERY_CACHE } from '@/model/endpoints';
import { useNotification } from '@iziping/ui';
import "./match.css"

interface LaunchMatchProps {
    match: MatchDetail;
    onSuccess: () => void;
}

const LaunchMatch: React.FC<LaunchMatchProps> = ({match, onSuccess}) => {
    const {t} = useTranslation();
    const {notify} = useNotification();
    const {selectedTournament} = useTournamentStore();
    const queryClient = useQueryClient();
    const {data: availableTables, isLoading, isError} = useFindAvailableTables({tournamentId: selectedTournament!.id});
    const [selectedTable, setSelectedTable] = useState<Table | null>(null); // État pour suivre la table sélectionnée

    const launchMatch = useLaunchMatch();

    const handleTableChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedTableId = event.target.value;
        const table = availableTables?.find(table => table.id === Number(selectedTableId));
        setSelectedTable(table || null);

    };

    const handleLaunchMatch = async () => {
        try {
            await launchMatch.mutateAsync({matchId: match.id, table: selectedTable});
            await queryClient.invalidateQueries({queryKey: [QUERY_CACHE.MATCHES_SEARCH_PENDING]});
            await queryClient.invalidateQueries({queryKey: [QUERY_CACHE.MATCHES_SEARCH_IN_PROGRESS]});
            await queryClient.invalidateQueries({queryKey: [QUERY_CACHE.MATCHES_BUSY_PLAYERS]});
            onSuccess();
        } catch (error: any) {
            notify(t(error.error), 'error');
        }
    };

    return (
        <div>
            {availableTables &&
                <select className={'select'} value={selectedTable ? selectedTable.id : ''} onChange={handleTableChange}>
                    <option value="">-- Sélectionner une table --</option>
                    {availableTables!.map((table: Table) => (
                        <option key={table.id} value={table.id}>
                            {table.number}
                        </option>
                    ))}
                </select>
            }
            <button className={'button'} onClick={handleLaunchMatch}>Lancer le match</button>
        </div>
    )
}

export default LaunchMatch;